import { Modal, Button, Typography } from "antd";
import { connect } from "react-redux";
import { acceptTerms } from "../../redux/actions/authActions";

const { Paragraph } = Typography;

const awsFileUrl =
  "https://prod-byponto-arquivos.s3.us-east-1.amazonaws.com/Termo+de+Uso+e+Politica+de+Privacidade.pdf";

function TermsOfUseModal({ visible, onClose, acceptTerms }) {
  const handleAccept = () => {
    acceptTerms();
    onClose();
  };

  return (
    <Modal
      title="Termos de uso e privacidade"
      open={visible}
      closable={false}
      maskClosable={false}
      footer={[
        <Button type="primary" onClick={handleAccept} key="agree">
          Li e aceito
        </Button>,
      ]}
    >
      <Paragraph style={{ fontWeight: "bold" }}>
        Antes de continuar, é importante que você conheça e concorde com os
        nossos Termos de Uso e Política de Privacidade.
      </Paragraph>
      <Paragraph>
        Eles explicam como usamos seus dados e quais são as regras para
        utilização da plataforma. Você pode acessar{" "}
        <a href={awsFileUrl} target="_blank" rel="noopener noreferrer">
          aqui
        </a>
        .
      </Paragraph>
    </Modal>
  );
}

const mapDispatchToProps = {
  acceptTerms,
};

export default connect(null, mapDispatchToProps)(TermsOfUseModal);
